module.exports = __webpack_public_path__ + "img/SARAT.bd092621.png";